import styled from "styled-components";


export const SlideMobileCommunityCardStyled = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px;
    gap: 8px;
    cursor: pointer;
    width: 100%;
    height: 100%;
    border-radius: 16px;
    
    &:hover {
        opacity: 0.8;
    }
`;

export const SlideMobileCommunityCardTwitterStyled = styled(SlideMobileCommunityCardStyled)`
    background: linear-gradient(108.13deg, rgba(81, 164, 236, 0.2) 0%, rgba(255, 255, 255, 0.2) 100.22%);
`;

export const SlideMobileCommunityCardYoutubeStyled = styled(SlideMobileCommunityCardStyled)`
    background: linear-gradient(108.13deg, rgba(235, 50, 35, 0.2) 0%, rgba(255, 255, 255, 0.2) 100.22%), var(--color-fill-backing);
`;

export const SlideMobileCommunityCardFacebookStyled = styled(SlideMobileCommunityCardStyled)`
   background: linear-gradient(108.13deg, rgba(70, 95, 150, 0.2) 0%, rgba(255, 255, 255, 0.2) 100.22%), var(--color-fill-backing);
`;

export const SlideMobileCommunityCardInstagramStyled = styled(SlideMobileCommunityCardStyled)`
    background: linear-gradient(108.13deg, rgba(73, 97, 202, 0.2) 0%, rgba(215, 65, 128, 0.2) 28.28%, rgba(240, 77, 93, 0.2) 72.15%, rgba(255, 183, 79, 0.2) 100.22%);
`;

export const SlideMobileCommunityCardTelegramStyled = styled(SlideMobileCommunityCardStyled)`
    background: linear-gradient(108.13deg, rgb(63, 178, 222, 0.2) 0%, rgba(255, 255, 255, 0.2) 100.22%), var(--color-fill-backing);
`;